import { tv } from 'tailwind-variants';

import type { SecurityLevel } from './utils';

/**
 * Single source of truth for level-driven presentation shared between the
 * full Security Audit panel and the preview popover.
 */

export const securityLevelContainerBg = tv({
  variants: {
    level: {
      Neutral: ['bg-token-alphalight-100'],
      Pending: ['bg-token-alphalight-100'],
      Risky: ['bg-token-orange-200'],
      Danger: ['bg-token-red-200'],
      Safe: ['bg-token-green-300'],
    },
  },
  defaultVariants: {
    level: 'Neutral',
  },
});

export const securityLevelTextColor = tv({
  variants: {
    level: {
      Neutral: ['text-token-gray-1000'],
      Pending: ['text-token-gray-1000'],
      Risky: ['text-token-orange-1100'],
      Danger: ['text-token-red-1000'],
      Safe: ['text-token-green-1000'],
    },
  },
  defaultVariants: {
    level: 'Neutral',
  },
});

/**
 * Radial-gradient overlay drawn behind the badge. `background` and `opacity`
 * are applied via inline style because tailwind-variants cannot represent these
 * gradients as utility classes.
 */
export const SECURITY_LEVEL_GRADIENT: Record<
  SecurityLevel,
  { background: string; opacity: number }
> = {
  Neutral: {
    background:
      'radial-gradient(50% 50% at 50% 50%, rgba(146, 148, 166, 1) 0%, rgba(191, 192, 203, 0) 100%)',
    opacity: 0.1,
  },
  Pending: {
    background:
      'radial-gradient(50% 50% at 50% 50%, rgba(146, 148, 166, 1) 0%, rgba(191, 192, 203, 0) 100%)',
    opacity: 0.1,
  },
  Risky: {
    background:
      'radial-gradient(57.79% 58.91% at 51.75% 41.12%, #FF9A3B 0%, rgba(225, 197, 54, 0.00) 100%)',
    opacity: 0.15,
  },
  Danger: {
    background: 'radial-gradient(50% 50% at 50% 50%, #FF004D 0%, rgba(255, 127, 127, 0.00) 100%)',
    opacity: 0.1,
  },
  Safe: {
    background: 'radial-gradient(50% 50% at 50% 50%, #00FF00 0%, rgba(0, 255, 0, 0.00) 100%)',
    opacity: 0.1,
  },
};
